module.exports = __webpack_public_path__ + "img/plus-pink.5dd2cb5c.svg";